import React, { useContext } from 'react';
import { Grid, Typography } from '@mui/material';
import { Screen } from '../../components';
import { makeStyles } from '@mui/styles';
import { Lock } from '@mui/icons-material';
import { PartnerContext } from '../../lib/contexts/PartnerContext';

const useStyles = makeStyles(() => ({
  screen: {
    width: '96%',
    margin: '10px auto auto',
  },
  lockIcon: {
    fontSize: 80,
    margin: '20vh auto 20px auto',
    display: 'block',
  },
  message: {
    textAlign: 'center',
    color: 'inherit',
  },
}));

const DeniedAccessScreen = () => {
  const classes = useStyles();
  const {
    state: { userRole },
  } = useContext(PartnerContext);

  return (
    <Screen
      title={'Access Denied - Diet ID'}
      showSidebarNav={true}
      admin={true}
    >
      <Grid
        container
        alignItems="center"
        spacing={0}
        className={classes.screen}
      >
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          spacing={0}
        >
          <Typography
            variant={'subtitle1'}
            className={classes.message}
          >
            <Lock className={classes.lockIcon} />
            Sorry, you don't have access to this page.
          </Typography>
          {userRole !== 'patient' && (
            <Typography
              sx={{ fontSize: '0.85rem' }}
              variant={'subtitle1'}
              className={classes.message}
            >
              Switch to Admin View to see this page.
            </Typography>
          )}
        </Grid>
      </Grid>
    </Screen>
  );
};

export default DeniedAccessScreen;
